import i18n from 'i18next';
import type { Avfall } from '../../services/rtkApi';

export type ValidationErrors = Record<string, string>;

/**
 * Validate avfall array and return validation errors
 */
export const validateAvfall = (avfall: Array<Avfall>): ValidationErrors => {
    const errors: ValidationErrors = {};

    avfall.forEach((item, index) => {
        if (item.mengde < 0) {
            errors[`${index}-mengde`] = i18n.t(
                'sustainability.prosjektAvfall.error.invalidMengde',
            );
        }
        if (!item.avfallTypeId) {
            errors[`${index}-type`] = i18n.t(
                'sustainability.prosjektAvfall.error.typeRequired',
            );
        }
    });

    return errors;
};

/**
 * Validate the manually entered klimagassberegning value.
 * Optional (null is allowed); when set it must be >= 0.
 */
export const validateKlimagassberegning = (
    klimagassberegning: number | null,
): ValidationErrors => {
    const errors: ValidationErrors = {};

    if (klimagassberegning !== null && klimagassberegning < 0) {
        errors.klimagassberegning = i18n.t(
            'sustainability.prosjektAvfall.error.invalidKlimagassberegning',
        );
    }

    return errors;
};

/**
 * Check if there are any validation errors
 */
export const hasValidationErrors = (errors: ValidationErrors): boolean => {
    return Object.keys(errors).length > 0;
};

/**
 * Clear validation error for a specific field
 */
export const clearFieldError = (
    errors: ValidationErrors,
    index: number,
    field: string,
): ValidationErrors => {
    const newErrors = { ...errors };
    delete newErrors[`${index}-${field}`];
    return newErrors;
};

/**
 * Clear all validation errors for a specific row
 */
export const clearRowErrors = (
    errors: ValidationErrors,
    index: number,
): ValidationErrors => {
    const newErrors = { ...errors };
    delete newErrors[`${index}-type`];
    delete newErrors[`${index}-mengde`];
    return newErrors;
};
